export class Noaccess {
  constructor() {}
}
